export type PageWindowItem = number | 'ellipsis';

const MAX_WITHOUT_ELLIPSIS = 7;

const range = (from: number, to: number): number[] =>
  Array.from({ length: Math.max(0, to - from + 1) }, (_, i) => from + i);

const withGaps = (pages: number[]): PageWindowItem[] =>
  pages.flatMap((page, index): PageWindowItem[] => {
    const previous = pages[index - 1];
    if (previous === undefined || page - previous === 1) return [page];
    if (page - previous === 2) return [previous + 1, page];
    return ['ellipsis', page];
  });

export const pageWindow = (
  page: number,
  pageCount: number
): PageWindowItem[] => {
  const total = Math.max(1, pageCount);
  if (total <= MAX_WITHOUT_ELLIPSIS) return range(1, total);
  const current = Math.min(Math.max(1, page), total);
  const visible = [
    ...new Set([1, current - 1, current, current + 1, total]),
  ].filter((value) => value >= 1 && value <= total);
  return withGaps(visible.sort((a, b) => a - b));
};
